import * as React from 'react'
import { css, styled } from '../../../../shared/styled-components'
import { Utils } from '../../../../shared/Utils'
import { OfficeInstance } from '../../../../models/Office'
import { useEffect } from 'react'
import * as ReactGA from 'react-ga'
import { OfficeListItemButtons } from '../OfficeListItemButtons'
import { breakpoint, styled } from '../../../../shared/styled-components'

interface IProps {
  office: OfficeInstance
  trackingSource?: string
  onVideoClick?: () => any
}

export const NewOfficeItem = ({ office, trackingSource, onVideoClick }: IProps) => {
  useEffect(() => {
    ReactGA.event({
      category: 'Offices',
      action: 'Display in ' + trackingSource,
      label: `${office.name} (ID ${office.id})`,
      nonInteraction: true,
    })
  }, [])

  return (
    <Container>
      <Top>
        {office.landingpage
          ? <NameLink href={office.landingpage} target="_blank"><OfficeName>{office.name}</OfficeName></a>
          : <OfficeName>{office.name}</OfficeName>
        }
        <Location>{office.fullAddress}</Location>
        {office.distance !== null && <Distance>
          Entfernung: <DistanceValue>{office.distance.toFixed(1)} km</DistanceValue>
        </Distance>}
      </Top>
      <Bottom>
        <ImageContainer>
          <Image />
          <ImageInfo>weitere Informationen</ImageInfo>
        </ImageContainer>
        <ButtonsContainer>
          <OfficeListItemButtons office={office} />
        </ButtonsContainer>
        {office.videoUrl && <VideoContainer style={{ backgroundImage: `url('${office.videoThumbnail}')`}} onClick={onVideoClick}>
            <PlayIcon src={Utils.getAssetPath('/assets/calculator/result/play-icon.svg')} />
        </VideoContainer>}
      </Bottom>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 2rem;
  background-color: ${(props) => props.theme.darkBlueColor};
  overflow: hidden;
  border-radius: 10px;
  @media print {
  -webkit-print-color-adjust: exact !important;   /* Chrome, Safari 6 – 15.3, Edge */
    color-adjust: exact !important;                 /* Firefox 48 – 96 */
    print-color-adjust: exact !important;           /* Firefox 97+, Safari 15.4+ */
   }
`

const Top = styled.div`
  flex: 0 0 40px;
  align-items: center;
  display: flex;
  flex-direction: row;
`

const OfficeName = styled.div`
  flex: 1;
  font-size: 15px;
  padding-left: 10px;
  @media (max-width: 950px) {
    font-size: 12px;
  }  
  @media (max-width: 600px) {
    flex-basis: 60%;
  }
`

const Location = styled.div`
  font-size: 13px;
  flex: 1;
  background: url('${Utils.getAssetPath('/assets/calculator/result/location-pin.svg')}') no-repeat left center;
  background-size: contain;
  padding-left: 1.2rem;
  @media (max-width: 950px) {
    font-size: 10px;
  }
  @media (max-width: 600px) {
    position: absolute;
    margin-left: calc(50% - 28px);
    margin-top: 100px;
    background-color: ${(props) => props.theme.blueColor};
    padding: 12px 2px 10px 25px;
    height: 36px;
    background-size: 20px;
    width: calc(50% - 22px);
    border-radius: 0 5px 5px 0;
    font-size: 9px;
    display: table;
    margin-bottom: 0.5rem;    
  }
`

const Distance = styled.div`
  flex: 1;
  font-size: 15px;
  text-align: right;
  padding-right: 10px;
  @media (max-width: 950px) {
    font-size: 12px;
  }
  @media (max-width: 600px) {
    font-size: 0px;
  }
`

const DistanceValue = styled.div`
  display: inline-block;
  color: ${(props) => props.theme.greenColor};
  @media (max-width: 600px) {
    font-size: 12px;
  }
`

const Bottom = styled.div`
  display: flex;
  flex-direction: row;
  @media (max-width: 600px) {
    flex-direction: row;
  }
`

const ImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  background: red;
  width: 150px;
  border-radius: 0px 0px 0px 10px;
  overflow: hidden;
  @media (max-width: 600px) {
    flex-basis: 48%;
  }
  @media print { 
  -webkit-print-color-adjust: exact !important;   /* Chrome, Safari 6 – 15.3, Edge */
    color-adjust: exact !important;                 /* Firefox 48 – 96 */
    print-color-adjust: exact !important;           /* Firefox 97+, Safari 15.4+ */
  }
`

const Image = styled.img`
  flex: 0 0 150px;
   @media (max-width: 600px) {
   flex: 0 0 200px;
   }
`

const ImageInfo = styled.div`
  align-items: center;
  font-size: 10px;
  background: ${(props) => props.theme.greenColor} url('${Utils.getAssetPath('/assets/calculator/result/person.svg')}')
    no-repeat 5px center;
  padding: 6px 20px 6px 25px;
  cursor: pointer;
  @media (max-width: 600px) {
  display: none;
  }
  @media print { 
  display: none;
  }
`

const VideoContainer = styled.div`
  flex: 0 0 250px;
  background: black no-repeat center center;
  background-size: 130%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 950px) {
    flex: 0 0 150px;
    background-size: 210%;
  }
  @media (max-width: 600px) {
    position: absolute;
    margin-left: calc(50% - 28px);
    margin-top: 156px;
    width: calc(50% - 20px);
    background-image: none !important;
    background-color: ${(props) => props.theme.darkBlueColor};
    border-radius: 0 5px 5px 0;
    height: 36px;
    justify-content: start;
    padding-left: 6px;
    width: calc(50% - 22px);
  }
  &:after {
    @media (max-width: 600px) {
     content: "Video ansehen";
     font-size: 14px;
     padding-left: 5px;
     color: ${(props) => props.theme.greenColor};
    }
  }
  @media print { 
  display: none;
  }
`

const NameLink = styled.a``

const PlayIcon = styled.img`
  width: 3rem;
  @media (max-width: 600px) {
  width: 20px;
  }
  `

const ButtonsContainer = styled.div`
    background: white;
  flex: 1;
  @media (max-width: 600px) {
    width: 50%;
  }
  `
